"use strict";
/** Περιγραφή ρόλου ανά οθόνη — κοινό frontend & mobile */
Object.defineProperty(exports, "__esModule", { value: true });
exports.screenInfoCatalog = void 0;
exports.resolveScreenInfoRule = resolveScreenInfoRule;
exports.resolveScreenInfo = resolveScreenInfo;
exports.shouldShowScreenInfoBanner = shouldShowScreenInfoBanner;
exports.resolveMobileScreenInfo = resolveMobileScreenInfo;
/**
 * Σειρά σημαντικότητας: πιο συγκεκριμένα paths πρώτα.
 * Υποστηρίζεται `*` στο τέλος για prefix (π.χ. `/offers/*`).
 */
exports.screenInfoCatalog = [
    {
        path: '/onboarding',
        message: 'Συμπλήρωσε στοιχεία επιχείρησης και προφίλ για να ενεργοποιηθούν προσφορές, πελάτες και δημόσια σελίδα.',
    },
    {
        path: '/appointments/new',
        when: 'with-actions',
        message: 'Ορίζεις ημερομηνία, ώρα και πελάτη· το ραντεβού εμφανίζεται στο εβδομαδιαίο ημερολόγιο.',
    },
    {
        path: '/appointments',
        when: 'with-actions',
        message: 'Προβολή σήμερα και των επόμενων 7 ημερών. Σύρε ένα ραντεβού για αλλαγή ώρας ή ημέρας χωρίς επανεπεξεργασία φόρμας.',
    },
    {
        path: '/customers/tasks/new',
        when: 'with-actions',
        message: 'Δημιούργησε εργασία ή υπενθύμιση και σύνδεσέ την με πελάτη και υπεύθυνο στην ομάδα.',
    },
    {
        path: '/customers/tasks',
        when: 'with-actions',
        message: 'Λίστα εργασιών και υπενθυμίσεων — φίλτραρε ανά κατάσταση, είδος και κείμενο αναζήτησης.',
    },
    {
        path: '/tasks/new',
        message: 'Προσθήκη εργασίας σε συγκεκριμένο πελάτη από τη ροή CRM.',
    },
    {
        path: '/tasks/*',
        message: 'Επεξεργασία κατάστασης, προθεσμίας και σχετικών στοιχείων μίας εργασίας.',
    },
    {
        path: '/tasks',
        message: 'Όλες οι εργασίες του workspace — χρήσιμο για follow-up και ανάθεση σε ομάδα.',
    },
    {
        path: '/customers/new',
        message: 'Πρόσθεσε όνομα και τηλέφωνο πελάτη για να τον χρησιμοποιείς στις προσφορές.',
    },
    {
        path: '/customers/*',
        message: 'Στοιχεία πελάτη, προσφορές, ραντεβού και εργασίες σε ένα μέρος.',
    },
    {
        path: '/customers',
        message: 'Λίστα πελατών — αναζήτηση και άνοιγμα καρτέλας πελάτη.',
    },
    {
        path: '/offers/capture',
        message: 'Πες ή γράψε τι χρειάζεται ο πελάτης, διάλεξε πελάτη και φτιάξε την προσφορά σε τρία βήματα.',
    },
    {
        path: '/offers/new',
        message: 'Πλήρης δημιουργία: τίτλος, ποσό, φωτογραφία σημειώσεων και επεξεργασία κειμένου πριν την αποθήκευση.',
    },
    {
        path: '/offers/*',
        message: 'Δες το κείμενο, στείλε στον πελάτη ή κατέβασε PDF.',
    },
    {
        path: '/offers',
        message: 'Όλες οι προσφορές — φίλτρα και «Γρήγορη προσφορά» για νέα από σημειώσεις.',
    },
    {
        path: '/projects/new',
        message: 'Νέο έργο — τίτλος, κατηγορία και περιγραφή. Μετά την αποθήκευση ανοίγει η σελίδα φωτογραφιών.',
    },
    {
        path: '/projects',
        message: 'Λίστα έργων ανά κατηγορία. Νέο έργο ή επεξεργασία σε ξεχωριστή σελίδα.',
    },
    {
        path: '/reviews',
        message: 'Αιτήματα αξιολογήσεων από πελάτες — έγκρινε τι δημοσιεύεται στο δημόσιο προφίλ.',
    },
    {
        path: '/notifications',
        message: 'Ειδοποιήσεις για αποδοχές προσφορών, CRM και υπενθυμίσεις — δεν χάνεις ενέργειες που χρειάζονται απάντηση.',
    },
    {
        path: '/expenses/new',
        message: 'Καταχώρηση εξόδου χειροκίνητα ή σάρωση απόδειξης για αυτόματη συμπλήρωση πεδίων.',
    },
    {
        path: '/expenses',
        message: 'Ιστορικό εξόδων — φίλτρα ανά έργο, κατηγορία και ημερομηνία για οικονομική εικόνα.',
    },
    {
        path: '/reports/weekly',
        message: 'Εβδομαδιαία επιχειρησιακή σύνοψη — KPI και προτεραιότητες για γρήγορη εικόνα της περιόδου.',
    },
    {
        path: '/reports/insights',
        message: 'Εκπρόθεσμες προσφορές, κορυφαίοι πελάτες και ραντεβού — με τον ίδιο πίνακα όπως στις Λειτουργίες.',
    },
    {
        path: '/reports/compare',
        message: 'Σύγκριση δεικτών και τάσεων μεταξύ δύο περιόδων (π.χ. μήνας με μήνα).',
    },
    {
        path: '/reports/profile',
        message: 'Επισκέψεις δημόσιου προφίλ, QR και απόδοση καναλιών προβολής.',
    },
    {
        path: '/reports/financials',
        message: 'Έξοδα, margin και οικονομικά ανά έργο ή περίοδο.',
    },
    {
        path: '/reports/operations',
        message: 'Εργασίες, follow-up και λειτουργικές καθυστερήσεις της ομάδας.',
    },
    {
        path: '/reports/crm',
        message: 'Funnel πελατών, στάδια pipeline και εκτιμώμενη αξία ευκαιριών.',
    },
    {
        path: '/reports/offers',
        message: 'Πόσες προσφορές έγιναν αποδεκτές, τι μένει ανοιχτό και πόσο κράτησε η απόφαση.',
    },
    {
        path: '/reports',
        message: 'Τα βασικά νούμερα της περιόδου. Από εδώ μπαίνεις στις ξεχωριστές αναφορές.',
    },
    {
        path: '/settings',
        message: 'Ρυθμίσεις λογαριασμού: στοιχεία επιχείνησης, ρόλος AI, εμφάνιση πλοήγησης και ασφάλεια.',
    },
    {
        path: '/billing',
        message: 'Συνδρομή και πακέτα — όρια χρήσης, αναβάθμιση και ιστορικό πληρωμών.',
    },
    {
        path: '/',
        message: 'Συνοπτική εικόνα: τι χρειάζεται προσοχή, πρόσφατες προσφορές και γρήγορες ενέργειες.',
    },
    {
        path: '/admin/settings',
        message: 'OpenAI, Viva και email: οι τιμές στη βάση παρακάμπτουν το .env όταν είναι συμπληρωμένες· κενό μυστικό = χωρίς αλλαγή.',
    },
    {
        path: '/admin/templates',
        message: 'Follow-up, αίτημα αξιολόγησης, αποδοχή προσφοράς — preview και ιστορικό εκδόσεων ανά πρότυπο.',
    },
    {
        path: '/admin/ai-roles',
        when: 'with-actions',
        message: 'Ρόλοι στο βασικό prompt του AI — οι χρήστες τους επιλέγουν από τις ρυθμίσεις.',
    },
    {
        path: '/admin/users',
        when: 'with-actions',
        message: 'Συνδρομές και πακέτα ανά χρήστη· πλάνο και πακέτα αλλάζουν μόνο μέσω billing.',
    },
    {
        path: '/admin/packages',
        when: 'with-actions',
        message: 'Κείμενα login, /packages και billing· οι τιμές ορίζονται στις Ρυθμίσεις.',
    },
    {
        path: '/admin/analytics',
        when: 'with-actions',
        message: 'Funnel δημόσιου προφίλ (φάση 2) και follow-up (φάση 3) — επιλογή παραθύρου ημερών.',
    },
    {
        path: '/admin/ai-usage',
        when: 'with-actions',
        message: 'Εκτιμώμενο κόστος OpenAI ανά χρήστη — κλήσεις, tokens και ανά λειτουργία (προσφορές, φωνή, OCR).',
    },
    {
        path: '/admin/ai-pricing',
        when: 'with-actions',
        message: 'Τιμές USD για εκτίμηση κόστους AI (ανά 1M tokens και Whisper ανά λεπτό) — αποθηκεύονται στη ΒΔ.',
    },
    {
        path: '/admin/operations',
        message: 'Προσφορές, αξιολογήσεις, follow-up jobs, OCR εξόδων και ειδοποιήσεις — μόνο ανάγνωση.',
    },
    {
        path: '/admin',
        when: 'with-actions',
        message: 'Στιγμιότυπο χρηστών, συνδρομών, όγκου προσφορών και growth funnels.',
    },
];
function normalizePath(pathname) {
    var _a, _b;
    const base = (_b = (_a = pathname.split('?')[0]) === null || _a === void 0 ? void 0 : _a.split('#')[0]) !== null && _b !== void 0 ? _b : '/';
    if (base.length > 1 && base.endsWith('/'))
        return base.slice(0, -1);
    return base || '/';
}
function pathMatches(rulePath, pathname) {
    if (rulePath.endsWith('/*')) {
        const prefix = rulePath.slice(0, -1);
        return pathname === prefix.slice(0, -1) || pathname.startsWith(prefix);
    }
    return pathname === rulePath;
}
/** Κανόνας info για path ή null */
function resolveScreenInfoRule(pathname) {
    const path = normalizePath(pathname);
    for (const rule of exports.screenInfoCatalog) {
        if (pathMatches(rule.path, path))
            return rule;
    }
    return null;
}
/** Επιστρέφει info κείμενο για path ή null αν δεν ορίζεται */
function resolveScreenInfo(pathname) {
    var _a, _b;
    return (_b = (_a = resolveScreenInfoRule(pathname)) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : null;
}
/** Εμφάνιση banner: hint πάντα ή μόνο με actions ανά κανόνα */
function shouldShowScreenInfoBanner(pathname, hasActions) {
    var _a;
    const rule = resolveScreenInfoRule(pathname);
    if (!rule)
        return hasActions;
    const when = (_a = rule.when) !== null && _a !== void 0 ? _a : 'always';
    if (when === 'with-actions')
        return hasActions;
    return Boolean(rule.message) || hasActions;
}
/** Mobile expo-router paths (χωρίς (tabs) group) */
function resolveMobileScreenInfo(pathname) {
    const normalized = normalizePath(pathname)
        .replace(/^\/\(tabs\)/, '')
        .replace(/^\/\(auth\)/, '');
    return resolveScreenInfo(normalized || '/');
}
